//desktop notification alerts

const state = {
  currentDesktopNotifications: {}
};

const getters = {
  getCurrentDesktopNotifications: (state) => state.currentDesktopNotifications,
  getCurrentDesktopNotificationForTag: (state) => (tag) => state.currentDesktopNotifications[tag],
};

const mutations = {
  addToCurrentDesktopNotifications(state, {tag, data}) {
    state.currentDesktopNotifications[tag] = data
  },
  removeFromCurrentDesktopNotifications(state, tag) {
    let currentNotifications = {...getters.getCurrentDesktopNotifications}
    delete currentNotifications[tag]
    state.currentDesktopNotifications = currentNotifications
  },
};

const actions = {
  // desktop notifications ------------------------------------------------
  checkDesktopNotifications({dispatch}) {
    dispatch('createNewDesktopNotification', {
      from: 'SPACEIN',
      icon: '',
      body: 'This is a test Notifictation',
      tag: 'test',
      type: 'invite'
    })
  },
  createNewDesktopNotification({dispatch}, data) {
    if(!data) return
    try {
      if (Notification.permission !== 'granted' && data.tag === 'test') {
        Notification.requestPermission()
        .then(permission => {
          if(permission === 'granted') {
            dispatch('sendDesktopNotification', data)
          } else {
            dispatch('popups/show/error', {message: 'Notifications have been blocked by your browser, to allow notifications please change your browser setting.'})
          }
        })
      } else {
        // var notification = new Notification("Hi there!");
        dispatch('sendDesktopNotification', data)
      }
    } catch (e) {
      console.error(e)
    }
  },
  sendDesktopNotification({getters,commit,dispatch}, { from, icon, body, tag, type }) {
    if(getters.getCurrentDesktopNotificationForTag(tag) && tag === 'test') {
      dispatch('popups/show/error', {message: 'The test notification has been sent, if using more than 1 screen the notification may appear on other screens.'})
    }
    if(getters.getCurrentDesktopNotificationForTag(tag)) return
    // creates new notification instance
    // saves reference to desktopNotications object
    let newNotification = new Notification(from, {
      icon,
      body,
      tag,
      requireInteraction: true
    });

    if(type === 'broadcast') {
      delete newNotification[icon]
    }

    if(tag === 'test') {
      dispatch('popups/show/error', {message: 'Test notification sent, if using more than 1 screen the notification may appear on other screens.'})
    }

    commit('addToCurrentDesktopNotifications', {tag, data: newNotification})

    // defines what happens onclick
    let notification = getters.getCurrentDesktopNotificationForTag(tag)
    notification.onclick = function () {
      window.focus();
      notification.close();
    };

    // listens for close events
    // removes from the object
    notification.onclose = function () {
      commit('removeFromCurrentDesktopNotifications', tag)
    };
  },
  updateDesktopNotification({getters, commit}, { tag }) {
    if (!getters.getCurrentDesktopNotificationForTag(tag)) return;
    let notification = getters.getCurrentDesktopNotificationForTag(tag)
    notification.close();
    commit('removeFromCurrentDesktopNotifications', tag)
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
